/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState } from 'react';
import PlansCardFeatures from './PlansCardFeatures';
import PaymentsAPI from 'api/PaymentsAPI';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import CancelPlanModal from './CancelPlanModal';
import RenewPlanModal from './RenewPlanModal';
import { Modal } from '@mui/material';
import PlansCardFooter from './PlansCardFooter';

interface IPlansTableCard {
  type: string;
  activeBtn: string;
  monthlyPrice: string;
  annualPrice: string;
  icon: any;
  cur_user: any;
  team: any;
  quantity: number;
  cusObj: any;
  cusId: string;
  activePlan: any;
  newPlan: any;
  setNewPlan: any;
  setPlanState: any;
  planState: any;
  proMonthlyObj: any;
  proAnnualObj: any;
  standardMonthlyObj: any;
  standardAnnualObj: any;
  entMonthlyObj: any;
  entAnnualObj: any;
  currentPlan: any;
  setCurrentPlan: any;
  subInfo: any;
}

const PlansTableCard: React.FC<IPlansTableCard> = ({ subInfo, setCurrentPlan, currentPlan, entAnnualObj, entMonthlyObj, proAnnualObj, proMonthlyObj, standardAnnualObj, standardMonthlyObj, planState, setPlanState, setNewPlan, newPlan, activePlan, cusId, cusObj, quantity, cur_user, team, type, activeBtn, annualPrice, monthlyPrice, icon }) => {
  const history = useHistory();
  const [ cancelMode, setCancelMode ] = useState<boolean>(false);
  const [ renewMode, setRenewMode ] = useState<boolean>(false);
  const proMonthlyPrice = process.env.REACT_APP_BITE_PRO_MONTHLY!;
  const proAnnualPrice = process.env.REACT_APP_BITE_PRO_ANNUAL!;
  const standardMonthlyPrice = process.env.REACT_APP_BITE_STANDARD_MONTHLY!;
  const standardAnnualPrice = process.env.REACT_APP_BITE_STANDARD_ANNUAL!;
  const entMonthlyPrice = process.env.REACT_APP_BITE_ENT_MONTHLY!;
  const entAnnualPrice = process.env.REACT_APP_BITE_ENT_ANNUAL!;

  const handleQuantityChange = (action: string) => {
    let newQuantity = planState.data.quantity;
    if (action === 'increase' && planState.data.quantity <= 98) {
      newQuantity++;
    }
    if (action === 'decrease' && planState.data.quantity >= 2) {
      newQuantity--;
    }
    setPlanState(
      {
        ...planState,
        data: {
          ...planState.data,
          quantity: newQuantity
        }
      }
    );
  };

  const handleNewPlanChange = (plan: string) => {
    if (plan === 'Standard') {
      setNewPlan('Standard');
      if (activeBtn === 'monthly') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: standardMonthlyObj
            }
          }
        );
      }
      if (activeBtn === 'annual') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: standardAnnualObj
            }
          }
        );
      }
    }
    if (plan === 'Pro') {
      setNewPlan('Pro');
      if (activeBtn === 'monthly') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: proMonthlyObj
            }
          }
        );
      }
      if (activeBtn === 'annual') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: proAnnualObj
            }
          }
        );
      }
    }
    if (plan === 'Enterprise') {
      setNewPlan('Enterprise');
      if (activeBtn === 'monthly') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: entMonthlyObj
            }
          }
        );
      }
      if (activeBtn === 'annual') {
        setPlanState(
          {
            ...planState,
            data: {
              ...planState.data,
              selectedPrice: entAnnualObj
            }
          }
        );
      }
    }
  };

  const cancelSubAtPeriodEnd = async(sub_id: string) => {
    const canceled = await PaymentsAPI.cancelSubAtPeriodEnd(sub_id);
    if (canceled?.success) {
      history.go(0);
    }
  };

  const renewSub = async(sub_id: string) => {
    const renewed = await PaymentsAPI.renewCanceledSub(sub_id);
    if (renewed?.success) {
      history.go(0);
    }
  };

  const createCustomerPortalSession = async(cus_id: string) => {
    const res = await PaymentsAPI.createCustomerPortalSession(cus_id);
    if (res.success) {
      window.location.assign(res.result);
    }
  };

  const createCheckoutSession = async(tier: string, freeTrialStatus: boolean) => {
    const adjustable = {
      adjustable_quantity: {
        enabled: true,
        minimum: 1,
        maximum: 99
      }
    };
    const nonAdjustable = {
      adjustable_quantity: {
        enabled: false,
      }
    };
    const standardObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? standardMonthlyPrice : standardAnnualPrice,
          adjustable_quantity: {
            enabled: true,
            minimum: 1,
            maximum: 99
          },
          quantity: quantity
        }
      ],
      freeTrial: false,
      freeTrialDays: 0,
      team_id: team.id,
      team_admin: team.attributes.team_admin[0],
      team_name: team.name,
      keycloakUserId: cur_user?.basics?.id,
      moduleName: 'BITE Standard',
    };
    const proObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? proMonthlyPrice : proAnnualPrice,
          adjustable_quantity: freeTrialStatus ? nonAdjustable.adjustable_quantity : adjustable.adjustable_quantity,
          quantity: freeTrialStatus ? 1 : quantity
        }
      ],
      freeTrial: freeTrialStatus,
      team_id: team.id,
      freeTrialDays: 0,
      team_admin: team.attributes.team_admin[0],
      team_name: team.name,
      keycloakUserId: cur_user?.basics?.id,
      moduleName: 'BITE Pro',
    };
    const entObj = {
      lineItems: [
        {
          price: activeBtn === 'monthly' ? entMonthlyPrice : entAnnualPrice,
          adjustable_quantity: {
            enabled: true,
            minimum: 1,
            maximum: 99
          },
          quantity: quantity
        }
      ],
      freeTrial: false,
      freeTrialDays: 0,
      team_id: team.id,
      team_admin: team.attributes.team_admin[0],
      team_name: team.name,
      keycloakUserId: cur_user?.basics?.id,
      moduleName: 'BITE Enterprise',
    };
    if (tier === 'standard') {
      const res = await PaymentsAPI.createCheckoutSession(standardObj, cusId);
      if (res.success) {
        window.location.assign(res.result);
      }
    }
    if (tier === 'pro') {
      const res = await PaymentsAPI.createCheckoutSession(proObj, cusId);
      if (res.success) {
        window.location.assign(res.result);
      }
    }
    if (tier === 'enterprise') {
      const res = await PaymentsAPI.createCheckoutSession(entObj, cusId);
      if (res.success) {
        window.location.assign(res.result);
      }
    }
  };

  if (activePlan.isLoading || cusObj.isLoading) {
    return (
      <div>
        <CircularProgress style={{ color: '#0E8BFF' }} />
      </div>
    );
  }

  return (
    <div className={`plans-table-card${type === newPlan ? '-selected' : ''}`}>
      <div className='plans-card-header' onClick={() => handleNewPlanChange(type)}>
        <div className='plans-card-upper-group'>
          <div className='plans-card-heading-section'>
            <div className='plans-card-type-text'>
              {type} plan
            </div>
          </div>
          <div className='plans-card-price-section'>
            {activeBtn === 'monthly' ? (
              <div className='plans-card-price-text'>
                {monthlyPrice}
              </div>
            ) : (
              <div className='plans-card-price-text'>
                {annualPrice}
              </div>
            )}
          </div>
          {activeBtn === 'monthly' && monthlyPrice === 'Contact Us' && (
            <div className='plans-card-support-text'>
              info@bitedata.io
            </div>
          )}
          {activeBtn === 'monthly' && monthlyPrice.includes('$') && (
            <div className='plans-card-support-text'>
              per month/per user
            </div>
          )}
          {activeBtn === 'annual' && annualPrice === 'Contact Us' && (
            <div className='plans-card-support-text'>
              info@bitedata.io
            </div>
          )}
          {activeBtn === 'annual' && annualPrice.includes('$') && (
            <div className='plans-card-support-text'>
              per month/per user
            </div>
          )}
        </div>
      </div>
      <div className='plans-card-content'>
        <div className='plans-users-text' onClick={() => handleNewPlanChange(type)}>
          Number of Seats
        </div>
        <div className='plans-users-btn-group'>
          {type === newPlan ? (
            <>
              <div className='plans-users-arrow-btn' onClick={() => handleQuantityChange('decrease')}>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M15.8333 9.99984H4.16667M4.16667 9.99984L10 15.8332M4.16667 9.99984L10 4.1665' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              <div className='plans-users-number-btn'>
                <div className='plans-users-number-btn-text'>
                  {planState.data.quantity}
                </div>
              </div>
              <div className='plans-users-arrow-btn' onClick={() => handleQuantityChange('increase')}>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M4.16666 9.99984H15.8333M15.8333 9.99984L10 4.1665M15.8333 9.99984L10 15.8332' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </>
          ) : (
            <>
              <div className='plans-users-arrow-btn-disabled'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M15.8333 9.99984H4.16667M4.16667 9.99984L10 15.8332M4.16667 9.99984L10 4.1665' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
              <div className='plans-users-number-btn'>
                <div className='plans-users-number-btn-text'>
                  0
                </div>
              </div>
              <div className='plans-users-arrow-btn-disabled'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M4.16666 9.99984H15.8333M15.8333 9.99984L10 4.1665M15.8333 9.99984L10 15.8332' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </>
          )}
        </div>
        <PlansCardFeatures type={type} handleNewPlanChange={handleNewPlanChange} />
        <PlansCardFooter
          cur_user={cur_user}
          cusId={cusId}
          cusObj={cusObj}
          setCancelMode={setCancelMode}
          setRenewMode={setRenewMode}
          createCheckoutSession={createCheckoutSession}
          createCustomerPortalSession={createCustomerPortalSession}
          type={type}
          activePlan={activePlan}
          handleNewPlanChange={handleNewPlanChange}
          planState={planState}
          currentPlan={currentPlan}
          setCurrentPlan={setCurrentPlan}
          team={team}
          newPlan={newPlan}
          subInfo={subInfo}
        />
      </div>
      <Modal
        open={cancelMode}
        onClose={() => setCancelMode(false)}
      >
        <CancelPlanModal cancelSub={cancelSubAtPeriodEnd} subInfo={subInfo} setCancelMode={setCancelMode} />
      </Modal>
      <Modal
        open={renewMode}
        onClose={() => setRenewMode(false)}
      >
        <RenewPlanModal renewSub={renewSub} subInfo={subInfo} setRenewMode={setRenewMode} />
      </Modal>
    </div>
  );
};

export default PlansTableCard;
